import { render } from "./RekionTopPage.vue?vue&type=template&id=4683f25c&scoped=true&ts=true"
import script from "./RekionTopPage.vue?vue&type=script&lang=ts"
export * from "./RekionTopPage.vue?vue&type=script&lang=ts"

import "./RekionTopPage.vue?vue&type=style&index=0&id=4683f25c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4683f25c"]])

export default __exports__